define(
    'viewmodels/secured/shares/tabs/documents/documents',[
        "viewmodels/ViewModelNotification",
        "viewmodels/secured/shares/context",
        "providers/dataprovider",
        "i19n!i19n/strings"
    ],
    function (ViewModelNotification, ctx, dataProvider, i19n) {
        var grid = null;
        var $grid = null;

        var vm = new ViewModelNotification(
        {
            i19n: i19n,
            listOfDocuments: ko.observable(),            
            shareid: ko.observable(),
            loaded: ko.observable(false)
        });

        vm.activate = function () {
            var self = this;

            var documentshareid = sessionStorage.getItem("documentsharedid");

            vm.shareid(documentshareid);

            if (grid) {
                grid.dataSource.read();
            }
        };
        vm.attached = function () {
            var self = this;

            self.notifications([]);

            $grid = $("#document-grid");            

            buildKendoGrid();
            
            var detailExportPromises = [];

            function buildKendoGrid() {
                var columns = [
                    { field: "documentId", hidden: true },
                    { field: "title", title: i19n.to.title},
                    { field: "extension", title: i19n.to.ext, width: 50 },
                    { title: '&nbsp;', template: kendo.template($("#document-link-command-template").html()), width: 360 },
                    { field: "docId", title: i19n.to.docid, width: 100 }                    
                    //{ field: "downloaded", title: i19n.to.downloaded, width: 110 }
                ];
                
                grid = $grid.kendoGrid({
                    excelExport: function (e) {
                        e.preventDefault();

                        var workbook = e.workbook;

                        $("#document-grid [data-role=grid]")
                        .each(function () {
                            $(this).data("kendoGrid").saveAsExcel();
                        });

                        $.when.apply(null, detailExportPromises)
                        .then(function () {
                            var detailExports = $.makeArray(arguments);

                            detailExports.sort(function (a, b) {
                                return a.masterRowIndex - b.masterRowIndex;
                            });

                            workbook.sheets[0].columns.unshift({ width: 30 });

                            //for (var i = 0; i < workbook.sheets[0].rows.length; i++) {
                            //    workbook.sheets[0].rows[i].cells.unshift({});
                            //}

                            for (var i = detailExports.length -1; i >= 0; i--) {
                                var masterRowIndex = detailExports[i].masterRowIndex + 1;
                                var sheet = detailExports[i].sheet;

                                for (var ci = 0; ci < sheet.rows.length; ci++) {
                                    if (sheet.rows[ci].cells[0].value) {
                                        sheet.rows[ci].cells.unshift({});
                                    }
                                }

                                [].splice.apply(workbook.sheets[0].rows, [masterRowIndex + 1, 0].concat(sheet.rows));
                            }
                            
                            kendo.saveAs({
                                dataURI: new kendo.ooxml.Workbook(workbook).toDataURL(),
                                fileName: "share-details-documents.xlsx"
                            });
                        });
                    },
                    dataBound: function () {
                        detailExportPromises = [];
                        //this.expandRow(this.tbody.find("tr.k-master-row").first());
                        //this.expandRow(this.tbody.find("tr.k-master-row"));

                        resizeGrid();
                    },
                    dataSource: getKendoGridDataSource(),
                    resizable: true,
                    sortable: true,
                    detailTemplate: kendo.template($("#documenttemplate").html()),
                    detailInit: detailInit,
                    columns: columns,
                    scrollable: true
                }).data("kendoGrid");


                $grid.off("click", ".k-grid-copy-link", "**");
                $grid.on("click", ".k-grid-copy-link", function (e) {
                    e.preventDefault();

                    var itm = grid.dataItem($(e.currentTarget).closest("tr"));
                    
                    var $button = $(e.toElement);
                    var $oo = $('<input id="gdl-' + itm.documentId + '" class="k-input k-textbox" style="width: 340px;"/>');

                    $oo.appendTo($button.parent());

                    $oo.val(itm.publicLink).select();
                    $button.hide();

                    $oo.on("keyup", function (e) {
                        if (e.keyCode == 27) {
                            $button.show();
                            $oo.off("keyup", "**");
                            $oo.off("blur", "**");
                            $oo.remove();
                        } else {
                            $oo.select();
                        }
                    });
                    $oo.on("blur", function (e) {
                        $button.show();
                        $oo.off("keyup", "**");
                        $oo.off("blur", "**");
                        $oo.remove();
                    });

                    return false;


                    //var p = {
                    //    shareexpiryhours: 24,
                    //    documents: [{ documentId: itm.documentId }]
                    //};
                    
                    //dataProvider.documents
                    //.getDocumentGeneratedPublicLinks(vm.shareid()) //'854c32ec-2b1a-4cdc-99d1-fb947e55149c')
                    //.done(function (data) {
                    //    if (data.documentLinks.length > 0) {
                    //        var items = _.map(data.documentLinks, function (itm) {
                    //            return {
                    //                filename: itm.documentLinkTitle,
                    //                link: itm.documentLinkUrl
                    //            };
                    //        });

                    //        if (items.length > 0) {
                    //            //var $temp = $("<input />");

                    //            //$("body").append($temp);

                    //            //$temp.val(items[0].link).select();

                    //            //document.execCommand("copy");

                    //            //$temp.remove();


                    //            var $button = $(e.toElement);
                    //            var $oo = $('<input id="gdl-' + itm.documentId + '" class="k-input k-textbox" style="width: 140px;"/>');

                    //            $oo.appendTo($button.parent());

                    //            $oo.val(itm.link).select();
                    //            $button.hide();

                    //            $oo.on("keyup", function (e) {
                    //                if (e.keyCode == 27) {
                    //                    $button.show();
                    //                    $oo.off("keyup", "**");
                    //                    $oo.off("blur", "**");
                    //                    $oo.remove();
                    //                }
                    //            });
                    //            $oo.on("blur", function (e) {
                    //                $button.show();
                    //                $oo.off("keyup", "**");
                    //                $oo.off("blur", "**");
                    //                $oo.remove();
                    //            });

                    //        } else {
                    //            toastr.error("No public link available", "");
                    //        }

                    //        function copyToClipboard(elem) {
                    //            // create hidden text element, if it doesn't already exist
                    //            var targetId = "_hiddenCopyText_";
                    //            var isInput = elem.tagName === "INPUT" || elem.tagName === "TEXTAREA";
                    //            var origSelectionStart, origSelectionEnd;
                    //            if (isInput) {
                    //                // can just use the original source element for the selection and copy
                    //                target = elem;
                    //                origSelectionStart = elem.selectionStart;
                    //                origSelectionEnd = elem.selectionEnd;
                    //            } else {
                    //                // must use a temporary form element for the selection and copy
                    //                target = document.getElementById(targetId);
                    //                if (!target) {
                    //                    var target = document.createElement("textarea");
                    //                    target.style.position = "absolute";
                    //                    target.style.left = "-9999px";
                    //                    target.style.top = "0";
                    //                    target.id = targetId;
                    //                    document.body.appendChild(target);
                    //                }
                    //                target.textContent = elem.textContent;
                    //            }
                    //            // select the content
                    //            var currentFocus = document.activeElement;
                    //            target.focus();
                    //            target.setSelectionRange(0, target.value.length);

                    //            // copy the selection
                    //            var succeed;
                    //            try {
                    //                succeed = document.execCommand("copy");
                    //            } catch (e) {
                    //                succeed = false;
                    //            }
                    //            // restore original focus
                    //            if (currentFocus && typeof currentFocus.focus === "function") {
                    //                currentFocus.focus();
                    //            }

                    //            if (isInput) {
                    //                // restore prior selection
                    //                elem.setSelectionRange(origSelectionStart, origSelectionEnd);
                    //            } else {
                    //                // clear temporary content
                    //                target.textContent = "";
                    //            }
                    //            return succeed;
                    //        }
                    //    }
                    //})
                    //.fail(function (e) {
                    //    e.stopPropagation = true;
                        
                    //    console.error(e);
                    //});

                    //dataProvider.documents
                    //.resendDocumentShareEmailLink(vm.shareid(), itm.documentShareRecipientId)
                    //.done(function () {
                    //    vm.notify(1, i19n.to.resendemaildocumentsharelinkdone);
                    //})
                    //.fail(function (e) {
                    //    e.stopPropagation = true;
                    //    vm.notify(e.error);
                    //});

                    return false;
                });
            };
            function detailInit(e) {
                var columns = [
                    { field: "documentShareRecipientId", hidden: true },
                    { field: "recipient", title: i19n.to.recipient, width: 200 },
                    { field: "organisation", title: i19n.to.organisation },
                    { field: "downloaded", title: i19n.to.downloaded, template: "#var field=downloaded# #= field != null ? kendo.toString(field,'g') : '' #", width: 170 } //d MMM yyyy hh:mm tt
                ];

                var deferred = $.Deferred();
                var masterRowIndex = e.masterRow.index("#document-grid .k-master-row");
                
                detailExportPromises.push(deferred);
                
                $("<div/>")
                .appendTo(e.detailCell).kendoGrid({
                    excelExport: function (e) {
                        e.preventDefault();
                        
                        deferred.resolve({
                            masterRowIndex: masterRowIndex,
                            sheet: e.workbook.sheets[0]
                        });
                    },
                    dataSource: getSubKendoGridDataSource(e.data.recipients),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    sortable: true,
                    scrollable: true
                });
            }
            function getKendoGridDataSource() {
                var schema = {
                    model: {
                        id: "documentId",
                        fields: {
                            documentId: { type: "string" },
                            title: { type: "string" },
                            extension: { type: "string" },
                            docId: { type: "string" },
                            downloaded: { type: "date" },
                            isPublic: { type: 'boolean' },
                            publicLink: {type: 'string'}
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            self.loadData(vm.shareid())
                            .done(function () {
                                dataProvider.documents
                                .getDocumentGeneratedPublicLinks(vm.shareid()) //'854c32ec-2b1a-4cdc-99d1-fb947e55149c')
                                .done(function (links) {
                                    var documentLinks = [];

                                    if (links.documentLinks.length > 0) {
                                        documentLinks = _.map(links.documentLinks, function (itm) {
                                            return {
                                                documentId: itm.documentId,
                                                filename: itm.documentLinkTitle,
                                                publicLink: itm.documentLinkUrl
                                            };
                                        });
                                    }

                                    var isPublic = self.listOfDocuments().subject == "Public document links";

                                    self.listOfDocuments().documents = _.map(self.listOfDocuments().documents, function (itm) {
                                        var link = _.findWhere(documentLinks, {documentId: itm.documentId});
                                        itm.isPublic = isPublic;
                                        itm.publicLink = !link ? '' : link.publicLink;

                                        return itm;
                                    });

                                    callbacks.success(self.listOfDocuments().documents);

                                    setTimeout(function () {
                                        resizeGrid();
                                    }, 500);

                                })
                                .fail(function (e) {
                                    e.stopPropagation = true;

                                    console.error(e);

                                    callbacks.success(self.listOfDocuments().documents);

                                    setTimeout(function () {
                                        resizeGrid();
                                    }, 500);
                                });


                                
                            })
                            .fail(function (e) {
                                console.error(e);
                            });
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });

            };
            function getSubKendoGridDataSource(recipients) {
                var schema = {
                    model: {
                        id: "documentShareRecipientId",
                        fields: {
                            documentShareRecipientId: { type: "string" },
                            recipient: { type: "string" },
                            organisation: { type: "string" },
                            downloaded: { type: "date" }
                        }
                    }
                };

                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(recipients);

                            setTimeout(function () {
                                resizeGrid();
                            }, 500);
                        }
                    },
                    schema: schema,
                    pageSize: 999
                });
            };
            function resizeGrid() {
                if (!$grid)
                    return;

                var newGridHeight = $("#share-document-details-content").outerHeight() - 355;

                //- $(".page-header").outerHeight()
                //-$(".page-content").outerHeight()

                $grid.height(newGridHeight);

                grid.resize();
            }

            $(window).on("resize", _.debounce(resizeGrid, 250));
        };
        vm.loadData = function (documentshareid) {
            var self = this;
            var d = $.Deferred();
            
            ctx
            .loadForSharedDocumentDetails(documentshareid)
            .done(function (data) {
                self.listOfDocuments(data);

                d.resolve();
            })
            .fail(function (e) {
                d.reject('error loading in my share module : ' + e);
                console.log('error loading in my share module : ' + e);
            });

            return d.promise();
        };
        vm.exportToExcel = ko.asyncCommand({
            canExecute: function (isExecuting) {
                return !isExecuting;
            },
            execute: function (complete) {
                grid.expandRow(grid.tbody.find("tr.k-master-row"));
                grid.saveAsExcel();
                grid.collapseRow(grid.tbody.find("tr.k-master-row"));

                complete();
            }
        });

        return vm;

    }
 );

